import { EmptyState } from '@/shared/components';
import { MessagesArea } from './MessagesArea';
import { useCommunicationCatalog } from './useCommunicationCatalog';

/** Bereich „Nachrichten": was Gäste dieses Objekts wann von uns bekommen. */
export function CommunicationCatalogPanel({
  groupId,
  editable,
  objectName,
}: {
  groupId: string;
  editable: boolean;
  objectName?: string;
}) {
  const catalog = useCommunicationCatalog(groupId);

  // Der Fehlerschirm nur ohne Stand: scheitert ein späteres Nachladen, bleibt der Entwurf offen.
  if (!catalog.draft || !catalog.baseline) {
    if (!catalog.query.isError) {
      return (
        <section
          className="border-line bg-card min-h-48 animate-pulse rounded-lg border"
          aria-label="Nachrichten werden geladen"
        />
      );
    }
    return (
      <EmptyState
        icon="Error"
        title="Nachrichten konnten nicht geladen werden"
        description="Bitte versuchen Sie es erneut."
        action={{ label: 'Erneut laden', onClick: () => void catalog.query.refetch() }}
      />
    );
  }

  return (
    <section aria-labelledby="communication-catalog-title" className="space-y-4">
      <div>
        <h2 id="communication-catalog-title" className="text-ink font-serif text-2xl">
          Nachrichten
        </h2>
        <p className="text-ink-soft mt-1 max-w-3xl text-sm">
          Was Gäste dieses Objekts wann von uns bekommen. Leere Felder nutzen automatisch den
          StayOn-Standard – in beiden Sprachen.
        </p>
      </div>
      <MessagesArea catalog={catalog} editable={editable} objectName={objectName} />
    </section>
  );
}
